module.exports = __webpack_public_path__ + "img/search-index.ccf20145.png";